import { ActionReducer, INIT, UPDATE } from '@ngrx/store';
import { AppState } from '../app.state';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const hydrationMetaReducer = (
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> => {
  const platformId = inject(PLATFORM_ID);
  return (state, action) => {
    const isBrowser:boolean = isPlatformBrowser(platformId);
    if (action.type === INIT || action.type === UPDATE) {
      if (isBrowser) {
        const storageValue = sessionStorage.getItem('appState');
        if (storageValue) {
          try {
            return JSON.parse(storageValue);
          } catch {
            sessionStorage.removeItem('appState');
          }
        }
      }
    }
    const nextState = reducer(state, action);
    if (isBrowser) {
      sessionStorage.setItem('appState', JSON.stringify(nextState));
    }
    return nextState;
  };
};
